import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { NS } from '../../../../../i18n/constants/keys';
import { jobOpeningTypes } from '../../../../../utils/types/JobOpenings';
import { SIDEBAR_NAV_ITEMS } from '../constants/jobOpeningDetails.constants';
import { ISidebarButtonConfig } from '../Interfaces/sidebar.interface';

export const useJobOpeningSidebar = (jobOpeningElements: jobOpeningTypes[]): ISidebarButtonConfig[] => {
  const { t } = useTranslation(NS.adminPages);

  return useMemo(() => {
    return SIDEBAR_NAV_ITEMS.map((item) => {
      let disabled = false;
      if (item.requiredElement) {
        disabled = !jobOpeningElements.includes(item.requiredElement as jobOpeningTypes);
      }

      return {
        value: item.value,
        label: t(item.labelKey),
        Icon: item.Icon,
        disabled,
      };
    });
  }, [jobOpeningElements, t]);
};
